import React from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const Versement83 = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <CardBox bpad>
          <Column fill>
            {context.state.TypeSimulation === "Audit retraite" && (
              <Row>
                <Column>
                  <TextField
                    label="Salaire brut"
                    value={context.state["SalaireBrutContratRetraite" + ClientConjoint]}
                    onChange={context.handleInputChange("SalaireBrutContratRetraite" + ClientConjoint)}
                    dataType="ufloat"
                    format={{ thousands: " ", unit: " €", decimal: "," }}
                    normal
                  />
                </Column>
              </Row>
            )}
            <Row>
              <Column>
                <DropDown
                  label="Assiette de cotisation"
                  value={context.state.AssietteCotisation83}
                  options={[
                    { value: "AssietteSalaireBrut", label: "% du salaire brut" },
                    { value: "AssiettePass", label: "% du PASS" },
                  ]}
                  onChange={(e) => {
                    context.handleChangeAssietteCotisation83("AssietteCotisation83", "", e);
                  }}
                  normal
                />
              </Column>
            </Row>
            <Row tpad>
              <Column>
                <div className="prise-en-charge-container">
                  <div className="prise-en-charge-table-container">
                    <table className="mono">
                      <tbody>
                        <tr>
                          <td></td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                              Salarié
                            </label>
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                              Employeur
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                            <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                              Tranche A
                            </label>
                          </td>
                          <td>
                            <TextField
                              value={context.state.taux_retraite_trancheA_salarie83}
                              onChange={context.handleInputChange("taux_retraite_trancheA_salarie83")}
                              dataType="ufloat"
                              format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                              normal
                            />
                          </td>
                          <td>
                            <TextField
                              value={context.state.taux_retraite_trancheA_patronale83}
                              onChange={context.handleInputChange("taux_retraite_trancheA_patronale83")}
                              dataType="ufloat"
                              format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                              normal
                            />
                          </td>
                        </tr>
                        {context.state["AssietteCotisation83"] === "AssietteSalaireBrut" && (
                          <>
                            <tr>
                              <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                                <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                  Tranche B
                                </label>
                              </td>
                              <td>
                                <TextField
                                  value={context.state.taux_retraite_trancheB_salarie83}
                                  onChange={context.handleInputChange("taux_retraite_trancheB_salarie83")}
                                  dataType="ufloat"
                                  format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                  normal
                                />
                              </td>
                              <td>
                                <TextField
                                  value={context.state.taux_retraite_trancheB_patronale83}
                                  onChange={context.handleInputChange("taux_retraite_trancheB_patronale83")}
                                  dataType="ufloat"
                                  format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                  normal
                                />
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                                <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                  Tranche C
                                </label>
                              </td>
                              <td>
                                <TextField
                                  value={context.state.taux_retraite_trancheC_salarie83}
                                  onChange={context.handleInputChange("taux_retraite_trancheC_salarie83")}
                                  dataType="ufloat"
                                  format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                  normal
                                />
                              </td>
                              <td>
                                <TextField
                                  value={context.state.taux_retraite_trancheC_patronale83}
                                  onChange={context.handleInputChange("taux_retraite_trancheC_patronale83")}
                                  dataType="ufloat"
                                  format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                  normal
                                />
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                                <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                  Tranche D
                                </label>
                              </td>
                              <td>
                                <TextField
                                  value={context.state.taux_retraite_trancheD_salarie83}
                                  onChange={context.handleInputChange("taux_retraite_trancheD_salarie83")}
                                  dataType="ufloat"
                                  format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                  normal
                                />
                              </td>
                              <td>
                                <TextField
                                  value={context.state.taux_retraite_trancheD_patronale83}
                                  onChange={context.handleInputChange("taux_retraite_trancheD_patronale83")}
                                  dataType="ufloat"
                                  format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                  normal
                                />
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
};

export default Versement83;
